import { Button } from '../ui/button'
import { PanelLeftClose, PanelRightClose, Columns } from 'lucide-react'
import { cn } from '@/lib/utils'

type ViewMode = 'split' | 'chat' | 'preview'

interface ViewModeToggleProps {
  viewMode: ViewMode
  onViewModeChange: (mode: ViewMode) => void
}

export function ViewModeToggle({ viewMode, onViewModeChange }: ViewModeToggleProps) {
  return (
    <div className="inline-flex h-7 items-center justify-center rounded-lg bg-muted p-0.5 text-muted-foreground">
      <Button
        variant={viewMode === 'chat' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('chat')}
        className={cn(
          "h-5 w-7 px-0",
          viewMode === 'chat' && "shadow-sm"
        )}
        title="Chat only view"
      >
        <PanelRightClose className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant={viewMode === 'split' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('split')}
        className={cn(
          "h-5 w-7 px-0",
          viewMode === 'split' && "shadow-sm"
        )}
        title="Split view"
      >
        <Columns className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant={viewMode === 'preview' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('preview')}
        className={cn(
          "h-5 w-7 px-0",
          viewMode === 'preview' && "shadow-sm"
        )}
        title="Preview only view"
      >
        <PanelLeftClose className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}